module.exports = __webpack_public_path__ + "img/the-netherlands-external-causes-male.1ece2e56.png";